import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../../ApiGenericResponse";
import { AuthResponseEnum } from "./AuthResponseEnum";

export class LoginResponse extends ApiGenericResponse {
    authResponse: AuthResponseEnum;
    accountUnlockedAt: Date;
    token: string;
    refreshToken: string;
    organizationLicensesCloseToExpiration: boolean;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.status == 500) throw Error;
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.AuthResponse != null) this.authResponse = obj.AuthResponse;
        if (obj.AccountUnlockedAt != null) this.accountUnlockedAt = new Date(obj.AccountUnlockedAt);
        if (obj.Token != null) this.token = obj.Token;
        if (obj.RefreshToken != null) this.refreshToken = obj.RefreshToken;
        this.organizationLicensesCloseToExpiration = obj.OrganizationLicensesCloseToExpiration;
    }
}
